import { FaBars } from "react-icons/fa";
import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
    background:rgba(255, 179, 255, 0);
    height: 85px;
    display: flex;
    align-items:center;
    z-index: 12;
    font-size: 30px;
`;

export const NavLink = styled(Link)`
    color:rgb(255, 255, 255);
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;
`;

export const Bars = styled(FaBars)`
    display: none;
    color:rgb(255, 255, 255);
    @media screen and (max-width: 768px) {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 75%);
        font-size: 1.8rem;
        cursor: pointer;
    }
`;

export const NavMenu = styled.div`
    display: flex;
    align-items: center;

    /* Second Nav */
    /* margin-right: 24px; */
    /* Third Nav */
    width: 100vw;
    @media screen and (max-width: 768px) {
        display: none;
    }
`;